import(/* webpackMode: "eager" */ "/app/apps/bg-bond/app/[locale]/not-found.tsx");
